export const courseListData = [
  {
    CourseName: "Information About UI/UX Design Degree ",
    Students: "600",
    key: 1,
    Price: "$160",
    Ratings: "4.5 (300)",
    Status: "Published",
    Img: "course-01.jpg",
  },
  {
    CourseName: "Wordpress for Beginners - Master Wordpress Quickly ",
    Students: "500",
    key: 2,
    Price: "$180",
    Ratings: "4.2 (430)",
    Status: "Pending",
    Img: "course-02.jpg",
  },
  {
    CourseName: "Sketch from A to Z (2024): Become an app designer ",
    Students: "300",
    key: 3,
    Price: "$200",
    Ratings: "4.7 (140)",
    Status: "Draft",
    Img: "course-03.jpg",
  },
  {
    CourseName: "Build Responsive Real World Websites with Crash Course ",
    Students: "400",
    key: 4,
    Price: "$220",
    Ratings: "4.4 (260)",
    Status: "Published",
    Img: "course-04.jpg",
  },
  {
    CourseName: "Learn JavaScript and Express to become a Expert ",
    Students: "700",
    key: 5,
    Price: "$170",
    Ratings: "4.8 (180)",
    Status: "Published",
    Img: "course-05.jpg",
  },
  {
    CourseName: "Introduction to Python Programming ",
    Students: "450",
    key: 6,
    Price: "$150",
    Ratings: "4.8 (180)",
    Status: "Published",
    Img: "course-06.jpg",
  },
  {
    CourseName: "Build Responsive Websites with HTML5 and CSS3 ",
    Students: "620",
    key: 7,
    Price: "$130",
    Ratings: "4.9 (510)",
    Status: "Published",
    Img: "course-07.jpg",
  },
  {
    CourseName: "Information About Photoshop Design Degree ",
    Students: "550",
    key: 8,
    Price: "$190",
    Ratings: "4.6 (400)",
    Status: "Published",
    Img: "course-08.jpg",
  },
  {
    CourseName: "C# Developers Double Your Coding with Visual Studio ",
    Students: "240",
    key: 9,
    Price: "$140",
    Ratings: "4.1 (180)",
    Status: "Published",
    Img: "course-09.jpg",
  },
  {
    CourseName: "Complete HTML, CSS and Javascript Course ",
    Students: "380",
    key: 10,
    Price: "$110",
    Ratings: "4.3 (200)",
    Status: "Published",
    Img: "course-01.jpg",
  },
];

export const coursesList = [
  {
    title:
      "Formulasi Kosmetik Bahan Alam dan Sertifikasi Halal Produk Kosmetik",
    imageUrl:
      "https://jadipraktisi.com/wp-content/uploads/2025/04/10.-Formulasi-Kosmetik-BA-dan-Sertifikasi-Produk-750x465.jpg",
    imageAlt:
      "Formulasi Kosmetik Bahan Alam dan Sertifikasi Halal Produk Kosmetik",
    link: "https://jadipraktisi.com/courses/formulasi-kosmetik-bahan-alam-dan-sertifikasi-halal-produk-kosmetik/",
    category: {
      name: "Carijamu",
      url: "https://jadipraktisi.com/course-category/carijamu/?tutor-course-filter-category=71",
      color: "#1ebe12",
    },
    price: {
      original: "149.000",
      current: "75.000",
    },
    rating: 4,
    author: {
      name: "Mentor Expert",
      profileUrl: "https://jadipraktisi.com/profile/admin?view=student",
    },
    excerpt: "Mudah Jadi Praktisi!",
  },
  {
    title:
      "Sajian Sehat untuk Keluarga: Herbal Pilihan untuk Puasa Ramadan dan Lebaran",
    imageUrl:
      "https://jadipraktisi.com/wp-content/uploads/2025/03/Herbal-Puasa-Lebaran-Jadipraktisi-Carijamu-750x465.jpg",
    imageAlt:
      "Sajian Sehat untuk Keluarga: Herbal Pilihan untuk Puasa Ramadan dan Lebaran",
    link: "https://jadipraktisi.com/courses/sajian-sehat-untuk-keluarga-herbal-pilihan-untuk-puasa-ramadan-dan-lebaran/",
    category: {
      name: "Carijamu",
      url: "https://jadipraktisi.com/course-category/carijamu/?tutor-course-filter-category=71",
      color: "#1ebe12",
    },
    price: {
      original: "149.000",
      current: "75.000",
    },
    rating: 4,
    author: {
      name: "Mentor Expert",
      profileUrl: "https://jadipraktisi.com/profile/admin?view=student",
    },
    excerpt: "Mudah Jadi Praktisi!",
  },
  {
    title:
      "Strategi Pengembangan Obat Bahan Alam: Uji Toksisitas Praklinik (In Vivo) dan Prosedur Registrasi Produk",
    imageUrl:
      "https://jadipraktisi.com/wp-content/uploads/2025/02/Strategi-Pengembangan-OBA-Invivo-dan-Registrasi-ok-750x465.jpg",
    imageAlt:
      "Strategi Pengembangan Obat Bahan Alam: Uji Toksisitas Praklinik (In Vivo) dan Prosedur Registrasi Produk",
    link: "https://jadipraktisi.com/courses/strategi-pengembangan-obat-bahan-alam-uji-toksisitas-praklinik-in-vivo-dan-prosedur-registrasi-produk/",
    category: {
      name: "Carijamu",
      url: "https://jadipraktisi.com/course-category/carijamu/?tutor-course-filter-category=71",
      color: "#1ebe12",
    },
    price: {
      original: "149.000",
      current: "99.000",
    },
    rating: 4,
    author: {
      name: "Mentor Expert",
      profileUrl: "https://jadipraktisi.com/profile/admin?view=student",
    },
    excerpt: "Mudah Jadi Praktisi!",
  },
  {
    title:
      "Memanfaatkan Bahan Dapur Sebagai Herbal dan Edukasi Keluarga Tentang Herbal",
    imageUrl:
      "https://jadipraktisi.com/wp-content/uploads/2024/12/23.-Herbal-untuk-Keluarga-750x465.jpg",
    imageAlt:
      "Memanfaatkan Bahan Dapur Sebagai Herbal dan Edukasi Keluarga Tentang Herbal",
    link: "https://jadipraktisi.com/courses/memanfaatkan-bahan-dapur-sebagai-herbal-edukasi-keluarga-tentang-herbal/",
    category: {
      name: "Carijamu",
      url: "https://jadipraktisi.com/course-category/carijamu/?tutor-course-filter-category=71",
      color: "#1ebe12",
    },
    price: {
      original: "149.000",
      current: "49.000",
    },
    rating: 4,
    author: {
      name: "Mentor Expert",
      profileUrl: "https://jadipraktisi.com/profile/admin?view=student",
    },
    excerpt: "Mudah Jadi Praktisi!",
  },
  {
    title: "Membuat Produk Herbal & Mendirikan Industri Rumah Tangga",
    imageUrl:
      "https://jadipraktisi.com/wp-content/uploads/2024/11/22.-Herbal-IRT-750x465.jpg",
    imageAlt: "Membuat Produk Herbal & Mendirikan Industri Rumah Tangga",
    link: "https://jadipraktisi.com/courses/membuat-produk-herbal-mendirikan-industri-rumah-tangga/",
    category: {
      name: "Carijamu",
      url: "https://jadipraktisi.com/course-category/carijamu/?tutor-course-filter-category=71",
      color: "#1ebe12",
    },
    price: {
      original: " 19.000",
      current: " 4.000",
    },
    rating: 4,
    author: {
      name: "Mentor Expert",
      profileUrl: "https://jadipraktisi.com/profile/admin?view=student",
    },
    excerpt: "Mudah Jadi Praktisi!",
  },
  {
    title:
      "Pemahaman tentang Saintifikasi Jamu Bagi Tenaga Kesehatan dalam Pelayanan Kesehatan",
    imageUrl:
      "https://jadipraktisi.com/wp-content/uploads/2024/08/12.-Saintifikasi-Jamu-750x465.jpg",
    imageAlt:
      "Pemahaman tentang Saintifikasi Jamu Bagi Tenaga Kesehatan dalam Pelayanan Kesehatan",
    link: "https://jadipraktisi.com/courses/pemahaman-tentang-saintifikasi-jamu-bagi-tenaga-kesehatan-dalam-pelayanan-kesehatan/",
    category: {
      name: "Carijamu",
      url: "https://jadipraktisi.com/course-category/carijamu/?tutor-course-filter-category=71",
      color: "#1ebe12",
    },
    price: {
      original: " 19.000",
      current: " 7.000",
    },
    rating: 4,
    author: {
      name: "Mentor Expert",
      profileUrl: "https://jadipraktisi.com/profile/admin?view=student",
    },
    excerpt: "Belajar Herbal Jadi Mudah!",
  },
  {
    title: "Barista Jamu : Meracik Minuman Jamu Milenial Ala Cafe",
    imageUrl:
      "https://jadipraktisi.com/wp-content/uploads/2024/07/21.-Barista-Jamu-Meracik-Minuman-Jamu-Milenial-Ala-Cafe-750x465.jpg",
    imageAlt: "Barista Jamu : Meracik Minuman Jamu Milenial Ala Cafe",
    link: "https://jadipraktisi.com/courses/barista-jamu-meracik-minuman-jamu-milenial-ala-cafe/",
    category: {
      name: "Carijamu",
      url: "https://jadipraktisi.com/course-category/carijamu/?tutor-course-filter-category=71",
      color: "#1ebe12",
    },
    price: {
      original: " 19.000",
      current: " 9.000",
    },
    rating: 4,
    author: {
      name: "Mentor Expert",
      profileUrl: "https://jadipraktisi.com/profile/admin?view=student",
    },
    excerpt: "Belajar Herbal Jadi Mudah!",
  },
  {
    title:
      "Carijamu Fest : Merayakan Warisan Nusantara untuk Kesehatan dan Kesejahteraan",
    imageUrl:
      "https://jadipraktisi.com/wp-content/uploads/2024/06/20.-Carijamu-Fest-750x465.jpg",
    imageAlt:
      "Carijamu Fest : Merayakan Warisan Nusantara untuk Kesehatan dan Kesejahteraan",
    link: "https://jadipraktisi.com/courses/carijamu-fest-merayakan-warisan-nusantara-untuk-kesehatan-dan-kesejahteraan/",
    category: {
      name: "Carijamu",
      url: "https://jadipraktisi.com/course-category/carijamu/?tutor-course-filter-category=71",
      color: "#1ebe12",
    },
    price: {
      original: " 19.000",
      current: " 19.000",
    },
    rating: 4,
    author: {
      name: "Mentor Expert",
      profileUrl: "https://jadipraktisi.com/profile/admin?view=student",
    },
    excerpt: "Belajar Herbal Jadi Mudah!",
  },
];

export const topCourses = [
  {
    label: "Farmasi Industri",
    url: "https://chat.whatsapp.com/KOPecNmZPcoJjUPdoCPjlz",
  },
  {
    label: "Praktisi Klinis",
    url: "https://chat.whatsapp.com/Dds1e9UtXXQJHrXKq2LAex",
  },
  {
    label: "OBA, SK, Kosmetik",
    url: "https://chat.whatsapp.com/Ka3irkncYKPHaC0jBADMUB",
  },
  {
    label: "Info Loker Praktisi",
    url: "https://chat.whatsapp.com/KQprPt8NzMAIXjUU5FWGxj",
  },
  {
    label: "Distribusi",
    url: "https://chat.whatsapp.com/HXEKJ2Uxe8b72pD1dVxikm",
  },
  { label: "Dokter PPDS", url: "#" },
  { label: "Alkes-PKRT", url: "#" },
  { label: "Perawat", url: "#" },
  { label: "Bidan", url: "#" },
  { label: "Tenaga Lab Medis", url: "#" },
  { label: "Elektromedis", url: "#" },
];

export const testimoniCourses = [
  {
    star: 5,
    content: "Materi yang diberikan ringan dan mudah dipahami!",
    author: "Hamsyiatul Marivah",
    from: "Universitas Muhammadiyah Sidoarjo",
  },
  {
    star: 5,
    content:
      "Sudah bagus materinya, sudah ngena, cuman mungkin kalau ada season 2 nya yang lebih mendalam lagi.",
    author: "apt. Rini Irantika, S.Farm",
    from: "RS dr. Suyoto Pusrehab Kemhan",
  },
  {
    star: 5,
    content: "Excellent, banyak ilmu yang di dapat!",
    author: "apt. Agus Subarno, S.Si",
    from: "Apotik Naga Jaya",
  },
];
